import React from "react";
import Label from "../../atoms/Label";
import Input from "../../atoms/Input";
import Text from "../../atoms/Text";
import TextEntryProps from "./props";

const TextEntry = ({ label, details, input, options }: TextEntryProps) => {
  const { lock, alternativeLabel } = options ?? {};

  return (
    <div className={"vcl-text-entry-container"}>
      {!alternativeLabel && <Label text={label} isFor={input?.id} />}
      <Input
        {...input}
        disabled={lock?.isLocked ?? input?.disabled ?? false}
        placeholder={alternativeLabel ? label : input?.placeholder}
      />
      <Text {...details} text={details?.text ?? ""} hidden={!details} />
      <Text
        text={`Edit ${label}`}
        hidden={!lock?.isLocked}
        onClick={lock?.unlock}
        style={{ textDecoration: "underline", fontFamily: "Inter-Medium" }}
      />
    </div>
  );
};

export default TextEntry;
